"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const CampaignsListShowMorePopover_1 = require("./CampaignsListShowMorePopover");
const reducers_1 = require("../../reducers");
const ListItemButtonGroup = ({ campaign, pushToModal, publishedCampaignStatus }) => {
    const { status } = campaign;
    if (status === 'DRAFT') {
        return React.createElement(src_1.Button, { text: "Edit", size: "small", type: "primary", onClick: () => pushToModal('wizard') });
    }
    let icon;
    if (publishedCampaignStatus === 'SCHEDULED' || publishedCampaignStatus === 'UPCOMING') {
        icon = (React.createElement(src_1.GearIcon, { fill: src_1.charcoal, height: "20", width: "20", viewBox: "0 0 24 24", style: {
                marginRight: 8,
            }, onClick: (e) => {
                e.stopPropagation();
                pushToModal('settings');
            } }));
    }
    else {
        icon = (React.createElement(src_1.BarChartIcon, { fill: src_1.charcoal, height: "20", width: "20", viewBox: "0 0 24 24", style: {
                marginRight: 8,
            }, onClick: (e) => {
                e.stopPropagation();
                pushToModal('report');
            } }));
    }
    return (React.createElement("div", { style: { flex: 'none', width: 48 } },
        icon,
        React.createElement(CampaignsListShowMorePopover_1.default, { campaign: campaign, device: "Desktop", pushToModal: pushToModal })));
};
const mapStateToProps = (state, ownProps) => {
    const { id } = ownProps;
    return {
        campaign: reducers_1.getCampaign(state, id),
        publishedCampaignStatus: reducers_1.getPublishedCampaignLifecycleStatus(state, id),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, {})(React.memo(ListItemButtonGroup));
